exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".primary--text[data-v-b7c78700] input{caret-color:var(--primary_text)!important}.v-text-field-extended[data-v-b7c78700]{position:relative}.v-text-field-extended__spinner[data-v-b7c78700]{position:absolute;right:0;top:50%;transform:translateY(-50%)}.v-text-field-extended[data-v-b7c78700] .input-group--focused .icon{color:rgba(0,0,0,.54)!important}.v-text-field-extended[data-v-b7c78700] .input-group--text-field__suffix{color:rgba(0,0,0,.38)!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-b7c78700","scoped":true,"sourceMap":false}!./~/postcss-loader/lib!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/vuetify/VTextFieldExtended.vue
// module id = 1053
// module chunks = 22